export default __webpack_public_path__ + "static/media/prabhjeet.86548439.jpeg";